import { render, staticRenderFns } from "./Brief.vue?vue&type=template&id=989661d2&scoped=true"
import script from "./Brief.vue?vue&type=script&lang=js"
export * from "./Brief.vue?vue&type=script&lang=js"
import style0 from "./Brief.vue?vue&type=style&index=0&id=989661d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "989661d2",
  null
  
)

export default component.exports